import { SAVINGS_STAMP_SID_LIMIT, SAVINGS_STAMP_STORAGE_KEY } from "@cart-ui/components/savings-stamp/constants";
import { GlobalHeaderState, SwgyHeaderKeysList } from "@swiggy-private/checkout-core";
import { LocalStorage } from "@swiggy-private/core-ui";
import { cloneDeep, isEmpty } from "@swiggy-private/js-utils";

export const shouldFetchSavingsStampLottie = ({
    xpEnabled,
    title,
    subtitle,
    lottieData,
    lottieFailed,
}: {
    xpEnabled?: boolean;
    title?: string;
    subtitle?: string;
    lottieData: object | null;
    lottieFailed: boolean;
}) => xpEnabled && !isEmpty(title) && !isEmpty(subtitle) && isEmpty(lottieData) && !lottieFailed;

// using any here as lottie data wont have type defined
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function updateSavingsStampLottieData(lottieData: any, title: string, subtitle: string) {
    const newLottieData = cloneDeep(lottieData);

    // Done use `isEmpty` helper for below checks as empty string also will be treasted as true in isEmpty
    // But for this use case we need to update tile even empty string is there
    if (newLottieData?.assets[2]?.layers[0]?.t?.d?.k[0]?.s?.t != null) {
        newLottieData.assets[2].layers[0].t.d.k[0].s.t = title;
    }

    if (newLottieData?.assets[2]?.layers[1]?.t?.d?.k[0]?.s?.t != null) {
        newLottieData.assets[2].layers[1].t.d.k[0].s.t = subtitle;
    }

    return newLottieData;
}

export function getSavingsStampSidCount(): number {
    const currentSid = GlobalHeaderState.getHeader(SwgyHeaderKeysList.sid);
    const storedCount: { value: number; sid: string } | undefined = LocalStorage.getItem(SAVINGS_STAMP_STORAGE_KEY);

    if (storedCount === undefined || storedCount.sid !== currentSid) {
        LocalStorage.setItem(SAVINGS_STAMP_STORAGE_KEY, {
            value: 0,
            sid: currentSid,
        });
        return 0;
    }

    return storedCount.value;
}

export function updateSavingsStampSidCount(): void {
    LocalStorage.setItem(SAVINGS_STAMP_STORAGE_KEY, {
        value: getSavingsStampSidCount() + 1,
        sid: GlobalHeaderState.getHeader(SwgyHeaderKeysList.sid),
    });
}

export function canShowSavingsStamp({
    xpEnabled,
    title,
    subtitle,
    hasLottiePlayed,
    checkoutWebWPSidLimit,
    lottieData,
    isBillCollapsible,
    isBillUncollapsed,
}: {
    xpEnabled: boolean;
    title: string;
    subtitle: string;
    hasLottiePlayed: boolean;
    checkoutWebWPSidLimit: string | undefined;
    lottieData: object | null;
    isBillCollapsible: boolean;
    isBillUncollapsed: boolean;
}): boolean {
    const result = xpEnabled && !isEmpty(title) && !isEmpty(subtitle) && !hasLottiePlayed;

    if (!result) {
        return false;
    }

    const sidBasedLimit = Number(checkoutWebWPSidLimit) || SAVINGS_STAMP_SID_LIMIT;
    const sidBasedLimitNotYetReached = getSavingsStampSidCount() < sidBasedLimit;
    const renderConditionsAreFulfilled = !isEmpty(lottieData) && (isBillCollapsible ? isBillUncollapsed : true);

    return sidBasedLimitNotYetReached && renderConditionsAreFulfilled;
}
